import { TextLabelSmall } from '@/components/text/Texts';
import './divider.styles.css';
import { cn } from '../ui/cn';

export const PlainDivider = () => {
	return <hr />;
};

export const DividerWithText = ({ text, className }: { text: 'or', className?: string }) => {
	return <TextLabelSmall className={cn('divider text-primaryFixedDim', className)} text={text} />
};

export const LineDivider = () => {
	return <div className="separator" />;
};

export const HorizontalDivider = () => {
	return <div className="horizontal-divider" />;
};
